import { render, staticRenderFns } from "./PosProductVisual.vue?vue&type=template&id=b4cfaef0&scoped=true"
import script from "./PosProductVisual.vue?vue&type=script&lang=js"
export * from "./PosProductVisual.vue?vue&type=script&lang=js"
import style0 from "./PosProductVisual.vue?vue&type=style&index=0&id=b4cfaef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cfaef0",
  null
  
)

export default component.exports